<template>
	<div class="homepage">
		<div class="page-container">
			<b-carousel
				id="carousel1"
				indicators
				background="#ababab"
				controls
				:interval="4000"
				@sliding-start="onSlideStart"
				@sliding-end="onSlideEnd"
			>
				<template v-for="(item, i) in list">
					<a :href="item.link" target="_blank" :key="i">
						<b-carousel-slide
							class="img-fluid carousel-item"
							:style="`background-image:url(${item.img})`"
							style="background-size: auto 100%; background-position: center"
						/>
					</a>
				</template>
			</b-carousel>

			<div
				class="row-grid"
				align-y="center"
				style="padding: 5%; background: #baedfb"
			>
				<div class="rwd-s-6 center" style="margin: 0; padding: 0.5em 1em">
					<carousel
						:per-page="1"
						:autoplay-timeout="5000"
						autoplay
						loop
						style="width: 90%"
					>
						<slide>
							<img src="@/assets/home/carousel.png" width="100%" />
						</slide>
					</carousel>
				</div>
				<div
					class="rwd-s-6 col"
					style="color: #2c2e31; line-height: 1.6; padding: 0.5em 1em"
				>
					<h1 style="font-size: 1.5em; font-weight: bold; margin-bottom: 0.5em">
						<span style="display: inline-block;"
							>親子偶戲 ╳ 遊藝工坊 ╳ 偶家小食 ╳ 藝術裝置 ╳ 踩街遊行</span
						>
					</h1>
					<br />
					<p style="font-size: 1em">
						利澤限定的夏日親子藝術盛典—《2025卡樂趴遊藝節》熱鬧回歸！
						加拿大「影子狂熱劇團」帶來全球暢銷繪本 Pomelo 夢幻劇場版！
						精心規劃的創意手作、操偶體驗，讓孩子親手打造專屬藝術作品。
						此外更邀請人氣親子Podcast「維多叔叔的故事歡樂車」，
						多位藝術家為園區打造互動裝置藝術與遊行專屬大偶，
						創造沉浸式藝術新體驗！
						<br />
						<br />「卡樂趴」預約你的夏日歡樂時光，好看、好玩、好精彩！
					</p>
					<br />
					<a
						href="https://lizepuppet.oen.tw/events/2vtV8uZQDyl3YeJX2haceDGprqq"
						target="_blank"
						class="row"
						align-x="center"
						align-y="center"
						align-self="right"
						style="
							border-radius: 100px;
							background: #01b6e2;
							color: #fff;
							font-size: 1.25em;
							padding: 0.5em 1em;
						"
					>
						<span>了解更多 More Info</span>&emsp;
						<img src="@/assets/home/arrow.png" height="15" />
					</a>
					<br />
				</div>
			</div>

			<IndexSplit2CalenderNews></IndexSplit2CalenderNews>
			<MapSplit2AboutInfo />
		</div>
	</div>
</template>

<script>
import PageTitle from "@/components/page_title";
import IndexSplit2CalenderNews from "@/components/index_split2_calender_news";
import MapSplit2AboutInfo from "@/components/map_split2_about_info";
import { mapActions, mapState } from "vuex";
import { Carousel, Slide } from "vue-carousel";

export default {
	metaInfo: {
		title: "利澤國際偶戲藝術村",
	},
	name: "homepage",
	data() {
		return {
			list: [
				//https://lizepuppet.com.tw/program/apply
				//https://lizepuppet.com.tw/reservation/play
				{
					img: "/static/assets/home/banner01.jpg?t=123",
					link: null,
				},
				{
					img: "/static/assets/home/banner02.jpg?t=123",
					link: null,
				},
				{
					img: "/static/assets/home/banner03.jpg?t=123",
					link: null,
				},
				{
					img: "/static/assets/home/banner04.jpg?t=123",
					link: null,
				},
				{
					img: "/static/assets/home/banner05.jpg?t=123",
					link: null,
				},
				{
					img: "/static/assets/home/banner06.jpg?t=123",
					link: null,
				},
				{
					img: "/static/assets/home/banner07.jpg?t=123",
					link: null,
				},
			],
			sliding: 0,
			carouselPerPage: 3,
		};
	},
	mounted() {
		window.addEventListener("resize", this.handleResize);
	},
	methods: {
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		handleResize(event) {
			if (window.innerWidth > 1250) {
				this.carouselPerPage = 3;
			} else if (window.innerWidth > 900) {
				this.carouselPerPage = 2;
			} else {
				this.carouselPerPage = 1;
			}
		},
	},
	components: {
		Carousel,
		Slide,
		PageTitle,
		IndexSplit2CalenderNews,
		MapSplit2AboutInfo,
	},
	mounted() {
		if (window.innerWidth > 1250) {
			this.carouselPerPage = 3;
		} else if (window.innerWidth > 900) {
			this.carouselPerPage = 2;
		} else {
			this.carouselPerPage = 1;
		}
		$(".VueCarousel-navigation-prev").html(
			'<i class="fas fa-3x fa-caret-left"></i>'
		);
		$(".VueCarousel-navigation-next").html(
			'<i class="fas fa-3x fa-caret-right"></i>'
		);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'

.homepage
	#carousel1
	.carousel-inner
		width: 100%
		height: 600px
	.carousel-item
		background-size: cover
		background-position: center
		height: 600px
		width: 100%
	@media screen and (max-width:900px)
		.carousel-inner
			width: 100%
			height: 300px
		.carousel-item
          background-size: cover
          background-position: center
          height: 300px
          width: 100%
	.media-show
      width: 85%
      margin: 50px auto 180px auto
	@media screen and (max-width:350px)
		width: 70%
	.m-item
		+flexLayout('flex-start', 'col')
		padding-top: 20px
		iframe
          border-radius: 50px
          width: 355px
          height: 243px
		@media screen and (max-width:500px)
			border-radius: 40px
			width: 248px
			height: 170px
		@media screen and (max-width:350px)
			border-radius: 20px
			width: 85%
			height: 150px
		.VueCarousel-navigation-button
          transform: translateY(-10px)
		.VueCarousel-navigation-next:nth-child(1)
          left: 20px !important
          display: none
		.VueCarousel-navigation-next:nth-child(2)
          right: 20px !important
          display: none
		.text
          +flexLayout('start', 'col')
          width: 355px
          margin-top: 20px
		@media screen and (max-width:500px)
			width: 248px
		@media screen and (max-width:350px)
			width: 85%
		.subtitle
			font-size: 14px
			line-height: 1.5
		.date
			font-size: 12px
			margin-top: 4px
	.center
      +flexLayout('center', 'row')
      position: relative
      margin: 120px 0 40px 0
      text-align: center
      line-height: 1.5
	.subtitle
		font-size: 24px
		color: #222222
	.tree
		position: absolute
		top: 50%
		left: 50%
		transform: translateX(-50%) translateY(-50%)
		height: 76px
		width: auto
	.black-man
      margin: auto
      position: relative
      left: 50%
      transform: translateX(-50%)
      width: 120px
      top: -20px
</style>



// WEBPACK FOOTER //
// src/pages/homepage.vue